export default __webpack_public_path__ + "static/media/PocketeReader.9f2a8f9b.png";